export default [
    {
        name: 'Title',
        value: 's_title',
        largeWidth: true
    },
    {
        name: 'Description',
        value: 's_description',
    },
    {
        name: 'URL',
        value: 's_url',
        largeWidth: true
    },
    {
        name: 'Image URL',
        value: 's_image_url',
        largeWidth: true
    },
    {
        name: 'Display',
        value: 'b_display',
        boolean: true,
        smallWidth: true
    },
];